// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file api_proto/v1/admin_approval.proto (package api_proto.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api_proto/v1/admin_approval.proto.
 */
export const file_api_proto_v1_admin_approval: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * クレジット手動付与（request_type = credit_manual_grant）の実行パラメータ
 *
 * @generated from message api_proto.v1.CreditManualGrantPayload
 */
export type CreditManualGrantPayload = Message<"api_proto.v1.CreditManualGrantPayload"> & {
  /**
   * universal / dedicated
   *
   * @generated from field: string credit_type = 1;
   */
  creditType: string;

  /**
   * credit_type=dedicated のとき必須、universal では空
   *
   * @generated from field: string dedicated_permission_code = 2;
   */
  dedicatedPermissionCode: string;

  /**
   * 付与量（正の値）
   *
   * @generated from field: int64 amount = 3;
   */
  amount: bigint;

  /**
   * 有効な最終日（YYYY-MM-DD・JST）。**指定日の終わりまで有効** = 翌日 0:00 に失効する。
   * サーバは翌日 0:00 を credit_lots.expires_at として保存し、参照時は
   * AdminCreditLot.expires_on として同じ日付に戻す（doc/architecture/db/admin-approval-audit.md）
   *
   * @generated from field: string expires_on = 4;
   */
  expiresOn: string;

  /**
   * 付与理由（手動付与では必須。credit_lots.reason に記録される）
   *
   * @generated from field: string reason = 5;
   */
  reason: string;
};

/**
 * Describes the message api_proto.v1.CreditManualGrantPayload.
 * Use `create(CreditManualGrantPayloadSchema)` to create a new message.
 */
export const CreditManualGrantPayloadSchema: GenMessage<CreditManualGrantPayload> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin_approval, 0);

/**
 * 実行パラメータのスナップショット。request_type と oneof の選択は一致していなければならない
 *
 * @generated from message api_proto.v1.ApprovalRequestPayload
 */
export type ApprovalRequestPayload = Message<"api_proto.v1.ApprovalRequestPayload"> & {
  /**
   * @generated from oneof api_proto.v1.ApprovalRequestPayload.payload
   */
  payload: {
    /**
     * @generated from field: api_proto.v1.CreditManualGrantPayload credit_manual_grant = 1;
     */
    value: CreditManualGrantPayload;
    case: "creditManualGrant";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message api_proto.v1.ApprovalRequestPayload.
 * Use `create(ApprovalRequestPayloadSchema)` to create a new message.
 */
export const ApprovalRequestPayloadSchema: GenMessage<ApprovalRequestPayload> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin_approval, 1);

/**
 * @generated from message api_proto.v1.ApprovalRequestItem
 */
export type ApprovalRequestItem = Message<"api_proto.v1.ApprovalRequestItem"> & {
  /**
   * ULID
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * credit_manual_grant（現行唯一の種別）。廃止済み種別（credit_negative_setting。決定101）の
   * 過去行は生の文字列のまま返る
   *
   * @generated from field: string request_type = 2;
   */
  requestType: string;

  /**
   * 対象企業。企業に紐付かない操作は 0
   *
   * @generated from field: int64 company_id = 3;
   */
  companyId: bigint;

  /**
   * 対象企業名。企業に紐付かない操作・削除済みは空文字
   *
   * @generated from field: string company_name = 4;
   */
  companyName: string;

  /**
   * @generated from field: api_proto.v1.ApprovalRequestPayload payload = 5;
   */
  payload?: ApprovalRequestPayload;

  /**
   * pending / approved / rejected / executed / canceled
   *
   * @generated from field: string status = 6;
   */
  status: string;

  /**
   * @generated from field: int64 requested_by_admin_id = 7;
   */
  requestedByAdminId: bigint;

  /**
   * @generated from field: string requested_by_admin_name = 8;
   */
  requestedByAdminName: string;

  /**
   * 未決は 0
   *
   * @generated from field: int64 decided_by_admin_id = 9;
   */
  decidedByAdminId: bigint;

  /**
   * @generated from field: string decided_by_admin_name = 10;
   */
  decidedByAdminName: string;

  /**
   * CEO による承認バイパス実行
   *
   * @generated from field: bool is_bypassed = 11;
   */
  isBypassed: boolean;

  /**
   * 申請理由
   *
   * @generated from field: string reason = 12;
   */
  reason: string;

  /**
   * 承認・却下・バイパスの理由
   *
   * @generated from field: string decision_reason = 13;
   */
  decisionReason: string;

  /**
   * 決裁日時（RFC3339）。未決は空文字
   *
   * @generated from field: string decided_at = 14;
   */
  decidedAt: string;

  /**
   * 実行日時（RFC3339）。未実行は空文字
   *
   * @generated from field: string executed_at = 15;
   */
  executedAt: string;

  /**
   * 申請日時（RFC3339）
   *
   * @generated from field: string created = 16;
   */
  created: string;

  /**
   * 氏名未登録のAdminを画面で識別するためのフォールバック表示用。削除済み・不明は空文字。
   * 相互牽制の記録（決定29・決定37）として「誰が申請し、誰が決裁したか」を必ず追えるようにする。
   *
   * @generated from field: string requested_by_admin_email = 17;
   */
  requestedByAdminEmail: string;

  /**
   * @generated from field: string decided_by_admin_email = 18;
   */
  decidedByAdminEmail: string;
};

/**
 * Describes the message api_proto.v1.ApprovalRequestItem.
 * Use `create(ApprovalRequestItemSchema)` to create a new message.
 */
export const ApprovalRequestItemSchema: GenMessage<ApprovalRequestItem> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin_approval, 2);

/**
 * 承認申請の登録。ロールに関わらず全 Admin が行える
 *
 * @generated from message api_proto.v1.CreateApprovalRequestRequest
 */
export type CreateApprovalRequestRequest = Message<"api_proto.v1.CreateApprovalRequestRequest"> & {
  /**
   * @generated from field: string request_type = 1;
   */
  requestType: string;

  /**
   * @generated from field: int64 company_id = 2;
   */
  companyId: bigint;

  /**
   * @generated from field: api_proto.v1.ApprovalRequestPayload payload = 3;
   */
  payload?: ApprovalRequestPayload;

  /**
   * 申請理由（必須）
   *
   * @generated from field: string reason = 4;
   */
  reason: string;
};

/**
 * Describes the message api_proto.v1.CreateApprovalRequestRequest.
 * Use `create(CreateApprovalRequestRequestSchema)` to create a new message.
 */
export const CreateApprovalRequestRequestSchema: GenMessage<CreateApprovalRequestRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin_approval, 3);

/**
 * @generated from message api_proto.v1.CreateApprovalRequestResponse
 */
export type CreateApprovalRequestResponse = Message<"api_proto.v1.CreateApprovalRequestResponse"> & {
  /**
   * @generated from field: api_proto.v1.ApprovalRequestItem request = 1;
   */
  request?: ApprovalRequestItem;
};

/**
 * Describes the message api_proto.v1.CreateApprovalRequestResponse.
 * Use `create(CreateApprovalRequestResponseSchema)` to create a new message.
 */
export const CreateApprovalRequestResponseSchema: GenMessage<CreateApprovalRequestResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin_approval, 4);

/**
 * @generated from message api_proto.v1.ListApprovalRequestsRequest
 */
export type ListApprovalRequestsRequest = Message<"api_proto.v1.ListApprovalRequestsRequest"> & {
  /**
   * 絞り込み。空文字 = 全状態
   *
   * @generated from field: string status = 1;
   */
  status: string;

  /**
   * 絞り込み。0 = 全企業
   *
   * @generated from field: int64 company_id = 2;
   */
  companyId: bigint;

  /**
   * 1 始まり。0 は 1 として扱う
   *
   * @generated from field: int32 page = 3;
   */
  page: number;

  /**
   * 既定 20・上限 100
   *
   * @generated from field: int32 page_size = 4;
   */
  pageSize: number;
};

/**
 * Describes the message api_proto.v1.ListApprovalRequestsRequest.
 * Use `create(ListApprovalRequestsRequestSchema)` to create a new message.
 */
export const ListApprovalRequestsRequestSchema: GenMessage<ListApprovalRequestsRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin_approval, 5);

/**
 * @generated from message api_proto.v1.ListApprovalRequestsResponse
 */
export type ListApprovalRequestsResponse = Message<"api_proto.v1.ListApprovalRequestsResponse"> & {
  /**
   * 申請日時の新しい順
   *
   * @generated from field: repeated api_proto.v1.ApprovalRequestItem requests = 1;
   */
  requests: ApprovalRequestItem[];

  /**
   * 絞り込み後の総件数（ページング用）
   *
   * @generated from field: int64 total_count = 2;
   */
  totalCount: bigint;
};

/**
 * Describes the message api_proto.v1.ListApprovalRequestsResponse.
 * Use `create(ListApprovalRequestsResponseSchema)` to create a new message.
 */
export const ListApprovalRequestsResponseSchema: GenMessage<ListApprovalRequestsResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin_approval, 6);

/**
 * 承認 / 却下。approver / ceo のみ。自分の申請は承認も却下もできない（相互牽制。決定29）。
 * 承認した場合は同一トランザクションで payload を実行し executed まで進める
 *
 * @generated from message api_proto.v1.DecideApprovalRequestRequest
 */
export type DecideApprovalRequestRequest = Message<"api_proto.v1.DecideApprovalRequestRequest"> & {
  /**
   * ULID
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * true = 承認（実行まで進む）/ false = 却下
   *
   * @generated from field: bool approve = 2;
   */
  approve: boolean;

  /**
   * 却下時は必須
   *
   * @generated from field: string decision_reason = 3;
   */
  decisionReason: string;
};

/**
 * Describes the message api_proto.v1.DecideApprovalRequestRequest.
 * Use `create(DecideApprovalRequestRequestSchema)` to create a new message.
 */
export const DecideApprovalRequestRequestSchema: GenMessage<DecideApprovalRequestRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin_approval, 7);

/**
 * @generated from message api_proto.v1.DecideApprovalRequestResponse
 */
export type DecideApprovalRequestResponse = Message<"api_proto.v1.DecideApprovalRequestResponse"> & {
  /**
   * @generated from field: api_proto.v1.ApprovalRequestItem request = 1;
   */
  request?: ApprovalRequestItem;
};

/**
 * Describes the message api_proto.v1.DecideApprovalRequestResponse.
 * Use `create(DecideApprovalRequestResponseSchema)` to create a new message.
 */
export const DecideApprovalRequestResponseSchema: GenMessage<DecideApprovalRequestResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin_approval, 8);

/**
 * 申請の取り下げ。申請者本人・承認待ちのみ
 *
 * @generated from message api_proto.v1.CancelApprovalRequestRequest
 */
export type CancelApprovalRequestRequest = Message<"api_proto.v1.CancelApprovalRequestRequest"> & {
  /**
   * ULID
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message api_proto.v1.CancelApprovalRequestRequest.
 * Use `create(CancelApprovalRequestRequestSchema)` to create a new message.
 */
export const CancelApprovalRequestRequestSchema: GenMessage<CancelApprovalRequestRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin_approval, 9);

/**
 * @generated from message api_proto.v1.CancelApprovalRequestResponse
 */
export type CancelApprovalRequestResponse = Message<"api_proto.v1.CancelApprovalRequestResponse"> & {
  /**
   * @generated from field: api_proto.v1.ApprovalRequestItem request = 1;
   */
  request?: ApprovalRequestItem;
};

/**
 * Describes the message api_proto.v1.CancelApprovalRequestResponse.
 * Use `create(CancelApprovalRequestResponseSchema)` to create a new message.
 */
export const CancelApprovalRequestResponseSchema: GenMessage<CancelApprovalRequestResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin_approval, 10);

/**
 * 承認をバイパスした即時実行。ceo のみ。バイパスであることを記録に残す（決定4 / 18）
 *
 * @generated from message api_proto.v1.ExecuteApprovalRequestBypassRequest
 */
export type ExecuteApprovalRequestBypassRequest = Message<"api_proto.v1.ExecuteApprovalRequestBypassRequest"> & {
  /**
   * ULID
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * なぜ承認を飛ばしたか（必須）
   *
   * @generated from field: string reason = 2;
   */
  reason: string;
};

/**
 * Describes the message api_proto.v1.ExecuteApprovalRequestBypassRequest.
 * Use `create(ExecuteApprovalRequestBypassRequestSchema)` to create a new message.
 */
export const ExecuteApprovalRequestBypassRequestSchema: GenMessage<ExecuteApprovalRequestBypassRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin_approval, 11);

/**
 * @generated from message api_proto.v1.ExecuteApprovalRequestBypassResponse
 */
export type ExecuteApprovalRequestBypassResponse = Message<"api_proto.v1.ExecuteApprovalRequestBypassResponse"> & {
  /**
   * @generated from field: api_proto.v1.ApprovalRequestItem request = 1;
   */
  request?: ApprovalRequestItem;
};

/**
 * Describes the message api_proto.v1.ExecuteApprovalRequestBypassResponse.
 * Use `create(ExecuteApprovalRequestBypassResponseSchema)` to create a new message.
 */
export const ExecuteApprovalRequestBypassResponseSchema: GenMessage<ExecuteApprovalRequestBypassResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin_approval, 12);

/**
 * 監査ログ 1 件（admin_audit_logs テーブル。INSERT only・改変不可）
 *
 * @generated from message api_proto.v1.AdminAuditLogItem
 */
export type AdminAuditLogItem = Message<"api_proto.v1.AdminAuditLogItem"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * 操作した管理者
   *
   * @generated from field: int64 actor_admin_id = 2;
   */
  actorAdminId: bigint;

  /**
   * 削除済み・不明は空文字
   *
   * @generated from field: string actor_admin_name = 3;
   */
  actorAdminName: string;

  /**
   * <ドメイン>.<動作>（例: contract.create。SSOT は go/models/admin_audit_log.go）
   *
   * @generated from field: string action = 4;
   */
  action: string;

  /**
   * 対象企業。企業に紐付かない操作は 0
   *
   * @generated from field: int64 company_id = 5;
   */
  companyId: bigint;

  /**
   * @generated from field: string company_name = 6;
   */
  companyName: string;

  /**
   * 対象レコードの種別（company_contract / company_staff …）
   *
   * @generated from field: string target_type = 7;
   */
  targetType: string;

  /**
   * 対象レコードの ID（int PK と ULID の双方を扱うため文字列）
   *
   * @generated from field: string target_id = 8;
   */
  targetId: string;

  /**
   * 変更内容のスナップショット（JSON 文字列）。
   * 承認申請の payload と違い、監査ログは action ごとに構造が開いている（新しい操作を記録する
   * たびに増える）ため、型付き message にせず記録された JSON をそのまま返す
   *
   * @generated from field: string payload = 9;
   */
  payload: string;

  /**
   * 記録日時（RFC3339）
   *
   * @generated from field: string created = 10;
   */
  created: string;

  /**
   * 氏名未登録のAdminを画面で識別するためのフォールバック表示用。削除済み・不明は空文字。
   *
   * @generated from field: string actor_admin_email = 11;
   */
  actorAdminEmail: string;
};

/**
 * Describes the message api_proto.v1.AdminAuditLogItem.
 * Use `create(AdminAuditLogItemSchema)` to create a new message.
 */
export const AdminAuditLogItemSchema: GenMessage<AdminAuditLogItem> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin_approval, 13);

/**
 * @generated from message api_proto.v1.ListAdminAuditLogsRequest
 */
export type ListAdminAuditLogsRequest = Message<"api_proto.v1.ListAdminAuditLogsRequest"> & {
  /**
   * 絞り込み。0 = 全企業
   *
   * @generated from field: int64 company_id = 1;
   */
  companyId: bigint;

  /**
   * 絞り込み。空文字 = 全 action
   *
   * @generated from field: string action = 2;
   */
  action: string;

  /**
   * 1 始まり。0 は 1 として扱う
   *
   * @generated from field: int32 page = 3;
   */
  page: number;

  /**
   * 既定 50・上限 200
   *
   * @generated from field: int32 page_size = 4;
   */
  pageSize: number;
};

/**
 * Describes the message api_proto.v1.ListAdminAuditLogsRequest.
 * Use `create(ListAdminAuditLogsRequestSchema)` to create a new message.
 */
export const ListAdminAuditLogsRequestSchema: GenMessage<ListAdminAuditLogsRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin_approval, 14);

/**
 * @generated from message api_proto.v1.ListAdminAuditLogsResponse
 */
export type ListAdminAuditLogsResponse = Message<"api_proto.v1.ListAdminAuditLogsResponse"> & {
  /**
   * 記録日時の新しい順
   *
   * @generated from field: repeated api_proto.v1.AdminAuditLogItem logs = 1;
   */
  logs: AdminAuditLogItem[];

  /**
   * @generated from field: int64 total_count = 2;
   */
  totalCount: bigint;
};

/**
 * Describes the message api_proto.v1.ListAdminAuditLogsResponse.
 * Use `create(ListAdminAuditLogsResponseSchema)` to create a new message.
 */
export const ListAdminAuditLogsResponseSchema: GenMessage<ListAdminAuditLogsResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_admin_approval, 15);

